export function getTenantSubdomainFromUrl(): string | undefined {
    const subdomain = window.location.host.split('.')[0];
    return subdomain !== 'configuration' ? subdomain : undefined;
}

export function getBlankHref() {
    return '#';
}
